// Reference badges open entity details where the reader already is. The
// detail modals live outside this feature's import graph, so the host
// provides these handlers and renders the modals; without a provider a
// badge falls back to its plain record link.
import { createContext, useContext } from 'react';

/** The person whose compiled memory a citation badge opens. */
export type MemorySubject = Readonly<{
    readonly type: 'caregiver' | 'client';
    readonly id: string;
    readonly name: string;
}>;

export type EntityDetailHandlers = Readonly<{
    readonly openCaregiver: (caregiverId: string) => void;
    readonly openClient: (clientId: string) => void;
    // The care plan lives on the client record, opened at that tab.
    readonly openCarePlan: (clientId: string) => void;
    readonly openShift: (shiftId: string) => void;
    readonly openPlaybook: (playbookId: string) => void;
    // One guide per organization, so there is nothing to address it by.
    readonly openMemory: (subject: MemorySubject) => void;
}>;

export const EntityDetailContext = createContext<EntityDetailHandlers | null>(
    null,
);

export function useEntityDetailHandlers(): EntityDetailHandlers | null {
    return useContext(EntityDetailContext);
}
